import React, { useState, useEffect } from "react";
import MainButton from "../../common/MainButton";

const PrintTitle = ({ title, subtitle, date, shamsiDate, titles, changeableDate, hideDate }) => {
  const [_date, setDate] = useState(date);
  const [_changeable, setChangeable] = useState(changeableDate);

  useEffect(() => {
    setDate(date);
  }, [date]);

  useEffect(() => {
    setChangeable(changeableDate);
  }, [changeableDate]);

  const formatDate = (theDate) => {
    let dd = String(theDate.getDate()).padStart(2, "0");
    let mm = String(theDate.getMonth() + 1).padStart(2, "0");
    let yyyy = theDate.getFullYear();

    return `${yyyy}/${mm}/${dd}`;
  };

  const getTodayDate = () => {
    let today = new Date();
    return formatDate(today);
  };

  const handleDateChange = (e) => {
    let theDate = new Date(Date.parse(e.target.value));
    setDate(formatDate(theDate));
    toggleDateChangeable();
  };

  const toggleDateChangeable = () => {
    setChangeable(!_changeable);
  };

  const displayDate = String(_date ?? "").trim() || getTodayDate();
  const showShamsi = Boolean(String(shamsiDate || "").trim());

  return (
    <div className="title">
      <div className="wrapper">
        {titles
          ? titles.map((label, i) =>
              i === 0 ? <h2 key={i}>{label}</h2> : <h4 key={i}>{label}</h4>
            )
          : <h2>{title}</h2>}
        {subtitle ? <h3>{subtitle}</h3> : null}

        {hideDate ? null : changeableDate && !_changeable ? (
          <div style={{ display: "flex", flexDirection: "row-reverse" }}>
            <input onChange={handleDateChange} type={"date"} />
            <MainButton type="close" handleClick={toggleDateChangeable} />
          </div>
        ) : showShamsi ? (
          <div className="print-header-dates">
            <p
              className="print-header-date-gregorian"
              dir="ltr"
              onClick={changeableDate ? toggleDateChangeable : undefined}
            >
              {displayDate}
            </p>
            <p className="print-header-date-shamsi" dir="ltr">
              {shamsiDate}
            </p>
          </div>
        ) : (
          <p onClick={changeableDate ? toggleDateChangeable : undefined}>
            {displayDate}
          </p>
        )}
      </div>
    </div>
  );
};

export default PrintTitle;
